// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_229aG","visuallyhidden":"_2uEHt","hide-text":"OLdFD","center":"_3XD89","noprint":"_2WcQS","root":"_23z-f","title":"H6r3p"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/coupon-codes/styles/default.scss
 ** module id = 982
 ** module chunks = 2
 **/